/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Site } from './Site';
import {
    SiteFromJSON,
    SiteFromJSONTyped,
    SiteToJSON,
    SiteToJSONTyped,
} from './Site';
import type { SimpleDataPoint } from './SimpleDataPoint';
import {
    SimpleDataPointFromJSON,
    SimpleDataPointFromJSONTyped,
    SimpleDataPointToJSON,
    SimpleDataPointToJSONTyped,
} from './SimpleDataPoint';
import type { EpaNotification } from './EpaNotification';
import {
    EpaNotificationFromJSON,
    EpaNotificationFromJSONTyped,
    EpaNotificationToJSON,
    EpaNotificationToJSONTyped,
} from './EpaNotification';
import type { EpaOperatorNotificationStatusEnum } from './EpaOperatorNotificationStatusEnum';
import {
    EpaOperatorNotificationStatusEnumFromJSON,
    EpaOperatorNotificationStatusEnumFromJSONTyped,
    EpaOperatorNotificationStatusEnumToJSON,
    EpaOperatorNotificationStatusEnumToJSONTyped,
} from './EpaOperatorNotificationStatusEnum';
import type { NotificationReasonEnum } from './NotificationReasonEnum';
import {
    NotificationReasonEnumFromJSON,
    NotificationReasonEnumFromJSONTyped,
    NotificationReasonEnumToJSON,
    NotificationReasonEnumToJSONTyped,
} from './NotificationReasonEnum';

/**
 * Serializer for the EpaOperatorNotification model.
 * @export
 * @interface EpaOperatorNotification
 */
export interface EpaOperatorNotification {
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotification
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof EpaOperatorNotification
     */
    readonly owner: number;
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotification
     */
    readonly epaForm: string;
    /**
     * 
     * @type {EpaNotification}
     * @memberof EpaOperatorNotification
     */
    notification: EpaNotification;
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotification
     */
    readonly assigneeName: string;
    /**
     * 
     * @type {Site}
     * @memberof EpaOperatorNotification
     */
    nearestSite: Site | null;
    /**
     * 
     * @type {Array<Site>}
     * @memberof EpaOperatorNotification
     */
    otherNearSites: Array<Site> | null;
    /**
     * 
     * @type {SimpleDataPoint}
     * @memberof EpaOperatorNotification
     */
    dataPoint: SimpleDataPoint | null;
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotification
     */
    epaEmissionRecord?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotification
     */
    readonly epaIdentifiedSite: string;
    /**
     * 
     * @type {number}
     * @memberof EpaOperatorNotification
     */
    assignee?: number | null;
    /**
     * 
     * @type {NotificationReasonEnum}
     * @memberof EpaOperatorNotification
     */
    readonly notificationReason: NotificationReasonEnum;
    /**
     * 
     * @type {EpaOperatorNotificationStatusEnum}
     * @memberof EpaOperatorNotification
     */
    status?: EpaOperatorNotificationStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof EpaOperatorNotification
     */
    readonly investigationStartedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaOperatorNotification
     */
    readonly completedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaOperatorNotification
     */
    readonly submittedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaOperatorNotification
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaOperatorNotification
     */
    readonly updatedAt: Date | null;
}



/**
 * Check if a given object implements the EpaOperatorNotification interface.
 */
export function instanceOfEpaOperatorNotification(value: object): value is EpaOperatorNotification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('epaForm' in (value as Record<string, any>)) && !('epa_form' in (value as Record<string, any>))) || ((value as Record<string, any>)['epaForm'] === undefined && (value as Record<string, any>)['epa_form'] === undefined)) return false;
    if (!('notification' in value) || value['notification'] === undefined) return false;
    if ((!('assigneeName' in (value as Record<string, any>)) && !('assignee_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['assigneeName'] === undefined && (value as Record<string, any>)['assignee_name'] === undefined)) return false;
    if ((!('nearestSite' in (value as Record<string, any>)) && !('nearest_site' in (value as Record<string, any>))) || ((value as Record<string, any>)['nearestSite'] === undefined && (value as Record<string, any>)['nearest_site'] === undefined)) return false;
    if ((!('otherNearSites' in (value as Record<string, any>)) && !('other_near_sites' in (value as Record<string, any>))) || ((value as Record<string, any>)['otherNearSites'] === undefined && (value as Record<string, any>)['other_near_sites'] === undefined)) return false;
    if ((!('dataPoint' in (value as Record<string, any>)) && !('data_point' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataPoint'] === undefined && (value as Record<string, any>)['data_point'] === undefined)) return false;
    if ((!('epaIdentifiedSite' in (value as Record<string, any>)) && !('epa_identified_site' in (value as Record<string, any>))) || ((value as Record<string, any>)['epaIdentifiedSite'] === undefined && (value as Record<string, any>)['epa_identified_site'] === undefined)) return false;
    if ((!('notificationReason' in (value as Record<string, any>)) && !('notification_reason' in (value as Record<string, any>))) || ((value as Record<string, any>)['notificationReason'] === undefined && (value as Record<string, any>)['notification_reason'] === undefined)) return false;
    if ((!('investigationStartedAt' in (value as Record<string, any>)) && !('investigation_started_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['investigationStartedAt'] === undefined && (value as Record<string, any>)['investigation_started_at'] === undefined)) return false;
    if ((!('completedAt' in (value as Record<string, any>)) && !('completed_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['completedAt'] === undefined && (value as Record<string, any>)['completed_at'] === undefined)) return false;
    if ((!('submittedAt' in (value as Record<string, any>)) && !('submitted_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['submittedAt'] === undefined && (value as Record<string, any>)['submitted_at'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function EpaOperatorNotificationFromJSON(json: any): EpaOperatorNotification {
    return EpaOperatorNotificationFromJSONTyped(json, false);
}

export function EpaOperatorNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaOperatorNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'epaForm': json['epa_form'],
        'notification': EpaNotificationFromJSON(json['notification']),
        'assigneeName': json['assignee_name'],
        'nearestSite': SiteFromJSON(json['nearest_site']),
        'otherNearSites': (json['other_near_sites'] == null ? null : (json['other_near_sites'] as Array<any>).map(SiteFromJSON)),
        'dataPoint': SimpleDataPointFromJSON(json['data_point']),
        'epaEmissionRecord': json['epa_emission_record'] === undefined ? undefined : json['epa_emission_record'] === null ? null : json['epa_emission_record'],
        'epaIdentifiedSite': json['epa_identified_site'],
        'assignee': json['assignee'] === undefined ? undefined : json['assignee'] === null ? null : json['assignee'],
        'notificationReason': NotificationReasonEnumFromJSON(json['notification_reason']),
        'status': json['status'] == null ? undefined : EpaOperatorNotificationStatusEnumFromJSON(json['status']),
        'investigationStartedAt': (json['investigation_started_at'] == null ? null : new Date(json['investigation_started_at'])),
        'completedAt': (json['completed_at'] == null ? null : new Date(json['completed_at'])),
        'submittedAt': (json['submitted_at'] == null ? null : new Date(json['submitted_at'])),
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function EpaOperatorNotificationToJSON(json: any): EpaOperatorNotification {
    return EpaOperatorNotificationToJSONTyped(json, false);
}

export function EpaOperatorNotificationToJSONTyped(value?: Omit<EpaOperatorNotification, 'id'|'owner'|'epaForm'|'assigneeName'|'epaIdentifiedSite'|'notificationReason'|'investigationStartedAt'|'completedAt'|'submittedAt'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification': EpaNotificationToJSON(value['notification']),
        'nearest_site': SiteToJSON(value['nearestSite']),
        'other_near_sites': (value['otherNearSites'] == null ? null : (value['otherNearSites'] as Array<any>).map(SiteToJSON)),
        'data_point': SimpleDataPointToJSON(value['dataPoint']),
        'epa_emission_record': value['epaEmissionRecord'],
        'assignee': value['assignee'],
        'status': EpaOperatorNotificationStatusEnumToJSON(value['status']),
    };
}

